import { Dictionary } from '@/util/dictionary';
import { sound, Sound } from '@pixi/sound';

const sfxIds = [
	'achievement',
	'gachaAnimation',
	'gachaReveal',
	'buyChaching',
] as const;
export type SfxId = typeof sfxIds[number];


export const sfxUrls: { [T in SfxId]: string } = {
	achievement: 'audio/bgm/Stabfish_Unlock Achievement Sound V3_128K mp3.mp3',
	gachaAnimation: 'audio/bgm/Stabfish_Gacha Animation_Audio3_128Kmp3.mp3',
	gachaReveal: 'audio/sfx/Stabfish_Gacha Reveal Sound Efx3_128Kmp3.mp3',

	buyChaching: 'audio/sfx/Buying Cha-Ching.mp3',
};

const bgmIds = [
	'bgmMainMenu',
	'bgmGame',
	'armageddon',
] as const;
export type BgmId = typeof bgmIds[number];


export const bgmUrls: { [T in BgmId]: string } = {
	bgmMainMenu: 'audio/bgm/Stabfish_Menu_Let_s Get Into Water_128K mp3.mp3',
	bgmGame: 'audio/bgm/NEW_Stabfish_On The Run_V2_128K mp3.mp3',
	armageddon: 'audio/bgm/Stabfish_Map Armageddon_Stay Until The End_128K mp3.mp3',
};

export const sfxs: { [T in SfxId]: Sound } = {} as any;
for (const sfxId in sfxUrls) {
	if (Object.prototype.hasOwnProperty.call(sfxUrls, sfxId)) {
		const url = sfxUrls[sfxId];
		sfxs[sfxId] = sound.add(sfxId, {
			url,
			preload: true,
		});
	}
}
